import initLeafDecorations from './modules/leaf-decorations';
import initLogo from './modules/logo';
import initHeaderScroll from './modules/header-scroll';
import initFadeIn from './modules/fade-in';

function init() {
    initLogo();
    initHeaderScroll();
    initFadeIn();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
